import u from 'updeep';
import { handleActions } from 'redux-actions';
import * as actions from './translateActions';

const initialState = {
  isFetchingBooks: false,
  isFetchingMore: false,
  isFetchingFilters: false,
  filters: {},
  books: [],
  metadata: {},
  sourceLanguage: 'English',
  targetLanguage: '',
  isGlobalTranslationModalVisible: false,
  currentGlobalTranslationModalBook: {},
  isCheckingTranslations: false,
  availableTranslations: [],
  openTranslateTabLink: false,
  isFetchingOfflineTranslateFilters: false,
  offlineTranslateFilters: {},
  offlineTranslateSourceLanguage: 'English',
  offlineTranslateTargetLanguage: ''
};

export default handleActions({
  [actions.fetchBooks]: (state, action) => u({
    isFetchingBooks: true,
    books: []
  }, state),

  [actions.receiveBooks]: (state, action) => u({
    isFetchingBooks: false,
    books: action.payload.data,
    metadata: action.payload.metadata
  }, state),

  [actions.changeSourceLanguage]: (state, action) => u({
    sourceLanguage: action.payload.language
  }, state),

  [actions.changeTargetLanguage]: (state, action) => u({
    targetLanguage: action.payload.language
  }, state),

  [actions.fetchMore]: (state, action) => u({
    isFetchingMore: true
  }, state),

  [actions.receiveMore]: (state, action) => {
    const books = state.books.concat(action.payload.data)
    return u({
      isFetchingMore: false,
      books: books,
      metadata: action.payload.metadata
    }, state)
  },

  [actions.fetchFilters]: (state, action) => u({
    isFetchingFilters: true
  }, state),

  [actions.receiveFilters]: (state, action) => u({
    isFetchingFilters: false,
    filters: action.payload.data
  }, state),

  [actions.fetchCheckTranslations]: (state, action) => u({
    isCheckingTranslations: true
  }, state),

  [actions.receiveCheckTranslations]: (state, action) => u({
    isCheckingTranslations: false,
    availableTranslations: action.payload.data
  }, state),

  [actions.openTranslationModal]: (state, action) => u({
    isGlobalTranslationModalVisible: true,
    currentGlobalTranslationModalBook: action.payload.book,
    sectionClicked: action.payload.secClicked || null,
    openTranslateTabLink: action.payload.openTranslateTabLink || false,
    translateOfflineMode: action.payload.translateOfflineMode || false,
  }, state),

  [actions.closeTranslationModal]: (state, action) => u({
    isGlobalTranslationModalVisible: false,
    currentGlobalTranslationModalBook: null,
    openTranslateTabLink: false,
    translateOfflineMode: false
  }, state),
  
  [actions.changeOfflineTranslateSourceLanguage]: (state, action) => u({
    offlineTranslateSourceLanguage: action.payload.language
  }, state),

  [actions.changeOfflineTranslateTargetLanguage]: (state, action) => u({
    offlineTranslateTargetLanguage: action.payload.language
  }, state),

  [actions.fetchOfflineTranslateFilters]: (state, action) => u({
    isFetchingOfflineTranslateFilters: true
  }, state),

  [actions.receiveOfflineTranslateFilters]: (state, action) => u({
    isFetchingOfflineTranslateFilters: false,
    offlineTranslateFilters: action.payload.data
  }, state),


}, initialState);



// WEBPACK FOOTER //
// ./src/redux/translateReducer.js